import { FilterGroupType } from '../filters/enums/filter-group-type';

export interface ISavedSearch {
  searchQuery: Partial<SearchQuery>;
  name: string;
  emailResults: boolean;
}

export interface ISavedSearchItem extends ISavedSearch {
  id: number;
}

export interface SearchQuery {
  searchTerm: string;
  filters: ISavedSearchFilter[];
  page: number;
  size: number;
  cursor: Cursor;
  sorts: Sort[];
}

export interface ISavedSearchFilter {
  name: FilterGroupType;
  negated?: boolean;
  values: FilterValue[];
  filterValueOperation?: 'Or' | 'And'; // default is 'And'
  overrideNesting?: boolean;
}

export interface FilterValue {
  value: string;
  name: string;
  range: Range;
}

export interface Range {
  min: string;
  max: string;
}

export interface Cursor {
  previous: string;
  next: string;
}

export interface Sort {
  field: string;
  direction: 'Ascending' | 'Descending';
  sortFilter?: ISavedSearchFilter;
  nested?: boolean;
}

export class SavedSearch implements ISavedSearch {
  searchQuery: SearchQuery;
  name: string;
  emailResults: boolean;

  constructor(data: Partial<ISavedSearch>) {
    this.name = data.name ?? 'DefaultSearchName';
    this.searchQuery = {
      searchTerm: data.searchQuery?.searchTerm ?? '',
      filters: data.searchQuery?.filters.map(f => new SavedSearchFilter(f)) ?? [],
      page: data.searchQuery?.page ?? 1,
      size: data.searchQuery?.size ?? 10,
      cursor: data.searchQuery?.cursor ?? { previous: '', next: '' },
      sorts: data.searchQuery?.sorts ?? []
    };
    this.emailResults = data?.emailResults ?? false;
  }
}

export class SavedSearchFilter implements ISavedSearchFilter {
  name: FilterGroupType;
  negated?: boolean = false;
  values: FilterValue[];
  filterValueOperation?: 'Or' | 'And'; // default is 'And'
  overrideNesting?: boolean = false;

  constructor(data: Partial<ISavedSearchFilter>) {
    this.filterValueOperation = data?.filterValueOperation || 'And';
    this.name = data?.name || null;
    this.negated = data?.negated ?? false;
    this.overrideNesting = data?.overrideNesting ?? false;
    this.values = data?.values || [];
  }
}
